import { fromJS, Record } from 'immutable';
import { ReviewLastPaidInvoice } from './submodels/review-last-paid-invoice';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';

export const REVIEW_CLIENT_SCHEMA = Object.freeze({
  ID: '',
  NAME: '',
  EMAIL: '',
  LAST_PAID_INVOICE: ReviewLastPaidInvoice,
});
const RECORD = generateSchema(REVIEW_CLIENT_SCHEMA);
const KEYS: any = generateKeys(REVIEW_CLIENT_SCHEMA);

export class ReviewClient extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.LAST_PAID_INVOICE,
        value: props.get(KEYS.LAST_PAID_INVOICE)
          ? new ReviewLastPaidInvoice(this.lastPaidInvoice)
          : null,
      },
    ]);

    return selfModel as ReviewClient;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get lastPaidInvoice(): ReviewLastPaidInvoice {
    return this.get(KEYS.LAST_PAID_INVOICE);
  }
}
